var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-16",attrs:{"id":"app"}},[_c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',[_c('radaReserva')],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }